import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function UserPreferences({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Users Preferences'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

